
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {ApplicationActions, EditDocumentSeedRequest, EditPilotlessSeafaringSeedRequest, ResultError, PilotlessSeafaringDocumentApiModel} from "@/api-client";
    import IssueDocumentInnerComponent from "@/features/applications/components/issue-document/IssueDocumentInnerComponent";
    import IssueDocumentSignature from "@/features/applications/components/issue-document/IssueDocumentSignature.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";

    @Component({
        components: {
            AdditionalInfoButton,
            DatePicker,
            IssueDocumentSignature,
            LabelOptional,
        }
    })
    export default class IssuePilotlessSeafaring extends IssueDocumentInnerComponent {
        @Prop({required: true})
        issueDocumentDetails!: PilotlessSeafaringDocumentApiModel
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        errors!: ResultError;
        
        initialEditModel!: EditDocumentSeedRequest;

        validUntil = this.issueDocumentDetails.validUntil;
        issueDate = this.issueDocumentDetails.issueDate;
        additionalInfo = this.issueDocumentDetails.additionalInfo;

        mounted() {
            this.initialEditModel = this.getEditModel();
        }
        
        getEditModel(): EditDocumentSeedRequest {
            return new EditPilotlessSeafaringSeedRequest({additionalInfo: this.additionalInfo, issueDate: this.issueDate, validUntil: this.validUntil})
        }
    }
